import { GET_ROLES } from "services/url.service";
import { getDropDownTransform } from "../handleTransformation";

export const roleMutations = {};

export const roleQueries = {
  getRoles: {
    getUrl: ({allRoles}) =>  GET_ROLES(allRoles),
    transformResponse: (res) => getDropDownTransform(res , "name" , "id"),
    method: "GET",
  },
};
